var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-input-select',{attrs:{"label":_vm.label,"help-danger":_vm.helpDanger,"loading":_vm.bridgesMeta.loading,"options":_vm.bridges,"value":_vm.value},on:{"input":_vm.handleBridgeSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }